import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './pages'
import * as serviceWorker from './serviceWorker'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './redux/store'

const AppWithRouter = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
)

const AppWithRedux = () => (
  <Provider store={store}>
    <AppWithRouter/>
  </Provider>
)

ReactDOM.render(<AppWithRedux />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
